import React, { useState } from 'react';

export default function FaqAccordion({ heading, faqs }) {
  const [openIndex, setOpenIndex] = useState(0);

  if (!faqs?.length) return null;

  return (
    <section className="section faq-section">
      <div className="container">
        {heading && (
          <header className="section-header">
            <h2>{heading}</h2>
          </header>
        )}
        <div className="faq-list">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div className={`faq-item ${open ? 'open' : ''}`} key={item.question}>
                <button
                  type="button"
                  className="faq-trigger"
                  aria-expanded={open}
                  onClick={() => setOpenIndex(open ? -1 : index)}
                >
                  <span>{item.question}</span>
                  <span className="faq-icon" aria-hidden>
                    {open ? '−' : '+'}
                  </span>
                </button>
                {open && <p className="faq-answer">{item.answer}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
